module.exports = __webpack_public_path__ + "static/media/KTM RC 390.f703a6ea.png";